/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApproveProjectItemsCommand } from '../../models/approve-project-items-command';
import { ApproveProjectItemsCommandResult } from '../../models/approve-project-items-command-result';

export interface ApiProjectApproveProjectItemsPatch$Params {
      body?: ApproveProjectItemsCommand
}

export function apiProjectApproveProjectItemsPatch(http: HttpClient, rootUrl: string, params?: ApiProjectApproveProjectItemsPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<ApproveProjectItemsCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectApproveProjectItemsPatch.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApproveProjectItemsCommandResult>;
    })
  );
}

apiProjectApproveProjectItemsPatch.PATH = '/api/Project/ApproveProjectItems';
